<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";

    import Icon from "@components/Icon.svelte";

    import { videoControllerToken } from "./context_tokens";
    import VideoPlayerPauseIcon from "./icons/VideoPlayerPauseIcon.svelte";
    import VideoPlayerPlayIcon from "./icons/VideoPlayerPlayIcon.svelte";
    import { PAUSE_STATUS } from "./VideoController";
    import VideoPlayerUIButton from "./VideoPlayerUIButton.svelte";

    const videoController = getTypedContext(videoControllerToken);

    let status = videoController.currentStatus$;
    const handleClick = () => {
        if (status.getValue() === "PLAYING") {
            videoController.pause();
        } else {
            videoController.play();
        }
    };
</script>

<VideoPlayerUIButton on:click={handleClick}>
    {#if $status === PAUSE_STATUS}
        <Icon height="1.5rem" width="1.5rem">
            <VideoPlayerPlayIcon />
        </Icon>
    {:else}
        <Icon height="1.5rem" width="1.5rem">
            <VideoPlayerPauseIcon />
        </Icon>
    {/if}
</VideoPlayerUIButton>
